import { Ng2StateDeclaration } from '@uirouter/angular';

import { PoolListComponent } from './components/pool-list/pool-list.component';

export const poolsState: Ng2StateDeclaration = {
    // parent: 'app', // declares that 'pools' is a child of 'app'
    name: 'sim-config-pool',
    url: '/project/:projectId/configuration/pools',
    component: PoolListComponent,
    params: {
        projectId: {squash: true, value: null}
    }
};

export const POOLS_STATES = [
    poolsState
];
